import React from "react";
import ReactDOM from "react-dom/client";
import "./scss/App.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./app/store/store";
import { Provider } from "react-redux";
import { WebSocketProvider } from "./app/contexts/SocketContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <WebSocketProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </WebSocketProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
